<!--top Title Bar -->

@if (bannerMessage) {
  <div class="announcement-bar">
    <div [innerHTML]="bannerMessage"></div>
  </div>
}
@if (showTopHeader) {
  <nav data-testid="home-header-nav-bar" class="navbar navbar-expand-md navbar-dark bg-primary fixed-top top_nav mainheader-nav " [ngClass]="[banner]">
    <div>
      <a class="navbar-brand" href="javascript:void(0);">@if (!IsJTGO) {
        <img class="img-responsive" src="assets/NewJT7/img/logo.png" alt="">
      }</a>
    </div>
    <button class="navbar-toggler" type="button" data-toggle="collapse" aria-expanded="false" aria-label="Toggle navigation">
      <span (click)="toggleMobileMenu()" class="navbar-toggler-icon"></span>
    </button>
    <div data-testid="home-header-div-bar" [ngClass]="[showMobileMenu  === true ? 'collapse navbar-collapse show' : 'collapse navbar-collapse']">
      <ul data-testid="header-home-ul" class="navbar-nav ml-auto">
        @if (isDashbaordAllow) {
          <li [ngClass]="[activeMenu === 1 ? 'nav-item active' : 'nav-item']" (click)="setActiveMenu('1')">
            <a class="nav-link Home" data-testid="btn-home-home" id="Home" href="Home" (click)="navigateToMenu('1','Home'); $event.preventDefault();">{{'TitleBar.Home'|translate}}</a>
          </li>
        }
        @if (isJobAllowed) {
          <li [ngClass]="[activeMenu === 2 ? 'nav-item active' : 'nav-item']" (click)="setActiveMenu('2')">
            <a class="nav-link JobHeader" data-testid="btn-home-jobs" id="JobHeader" href="JobsAndTalents/Jobs/List" (click)="navigateToMenu('2','JobsAndTalents/Jobs/List'); $event.preventDefault();">{{'TitleBar.Jobs'|translate}}</a>
          </li>
        }
        @if (isAdvertisingPartnerEnabled && hasAdvertisingPartnerAccess) {
          <li [ngClass]="'nav-item'">
            <a class="nav-link Adverts"
              data-testid="btn-adverts"
              id="Adverts"
              (click)="createAdvertisingPartnerSsoSession()"
              [attr.aria-label]="'TitleBar.Adverts.AdvertsOpensNewTab' | translate">
              {{'TitleBar.Adverts.Title'|translate}}
            </a>
          </li>
        }
        @if (((isTalentPoolAllowed && isTalentCaptureAllowed) || isFeatureCRM || isFeatureRedeployment)) {
          @if (isTalentAllowed) {
            <li [ngClass]="[activeMenu === 3  ? ('nav-item dropdown active' + (activeTalentMenu === true? ' show' : '')) : 'nav-item dropdown']" (click)="setActiveMenu('3');activeTalentMenu === true?activeTalentMenu = false:activeTalentMenu = true;">
              <a class="nav-link dropdownTalent" id="dropdownTalent"  aria-haspopup="true" aria-expanded="false">
                {{'TitleBar.Talent.Talent'|translate}}
              </a>
              <div class="dropdown-menu" aria-labelledby="dropdownTalent" [class.show]="activeTalentMenu">
                <app-talent-pool-header-menu (byClickOnMenu)="byClickOnMenu($event)">
                </app-talent-pool-header-menu>
              </div>
            </li>
          }
        } @else {
          @if (isTalentPoolAllowed && !isFeatureCRM) {
            <li [ngClass]="[activeMenu === 3 ? 'nav-item active' : 'nav-item']" (click)="setActiveMenu('3')">
              <a class="nav-link PoolHeader" href="JobsAndTalents/Jobs/Talents/List" (click)="navigateToMenu('3',common.RouteUrls.Talents.List);$event.preventDefault();">{{'TitleBar.Talent.TalentPoolCaps'|translate}}</a>
            </li>
          }
          @if (isTalentCaptureAllowed && !isFeatureCRM) {
            <li [ngClass]="[activeMenu === 3 ? 'nav-item' : 'nav-item']" (click)="setActiveMenu('3')">
              <a class="nav-link CaptureHeader" href="JobsAndTalents/Capture/TalentCapture/List" (click)="navigateToMenu('3',common.RouteUrls.GradeFare.List);$event.preventDefault();">{{'TitleBar.Talent.TalentCaptureCaps'|translate}}</a>
            </li>
          }
        }
        @if (isSearchAllowed) {
          <li id="dropdownSearchli" [ngClass]="[activeMenu === 5 ? 'nav-item active' : 'nav-item']" (click)="setActiveMenu('5')">
            <a class="nav-link dropdownSearch" data-testid="btn-home-search" id="dropdownSearch" data-toggle="dropdown" (click)="navigateToMenu('5','Search/Index');$event.preventDefault();" href="Search/Index" aria-haspopup="true" aria-expanded="false">
              <!--<svg class="nav-link-icon" id="dropdownSearchsvg">
              <use xlink:href="assets/NewJT7/img/sprite.svg#Search"></use>
            </svg>-->
            {{'TitleBar.Search.Search'|translate}}
          </a>
          <!--<div class="dropdown-menu" aria-labelledby="dropdownSearch" [ngClass]="[activeSearchMenu   == true ? 'dropdown-menu show' : 'dropdown-menu']">-->
          <!--*ngIf="roleService.HasAccess( SecurityRoleItems.SmartSearch, accessType)"-->
          <!--<a class="dropdown-item" href="javascript:void(0)" (click)="navigateToMenu('5','Search/Jobs')">{{'TitleBar.Search.Jobs'|translate}}</a>
          <a class="dropdown-item" *ngIf="roleService.HasAccess(SecurityRoleItems.SearchCandidates, accessType)" href="javascript:void(0)" (click)="navigateToMenu('5','Search/Candidates')">{{'TitleBar.Search.Candidates'|translate}}</a>
          <a class="dropdown-item" *ngIf="roleService.HasAccess(SecurityRoleItems.SearchByKeywords, accessType)" href="javascript:void(0)" (click)="navigateToMenu('5','Search/Keyword')">{{'TitleBar.Search.KeywordSearch'|translate}}</a>
          <a class="dropdown-item" href="javascript:void(0)" (click)="navigateToMenu('5','Search/JobAlerts')">{{'TitleBar.Search.JobAlerts'|translate}}</a>
          <a class="dropdown-item" href="javascript:void(0)" (click)="navigateToMenu('5','Search/SmartSearch')">{{'TitleBar.Search.SmartSearch'|translate}}</a>
          <a class="dropdown-item" *ngIf="roleService.HasAccess(SecurityRoleItems.SaveSearch, accessType)" href="javascript:void(0)" (click)="navigateToMenu('5','Search/SavedSearch/List')">{{'TitleBar.Search.SavedSearch'|translate}}</a>
          <a class="dropdown-item" *ngIf="roleService.HasAccess(SecurityRoleItems.TalentPool, accessType)" href="javascript:void(0)" (click)="navigateToMenu('5','Search/Talents')">{{'TitleBar.Search.TalentSearch'|translate}}</a>-->
          <!--<a class="dropdown-item" href="javascript:void(0)" (click)="common.NavigateToRoute('Search/Jobs')">{{'TitleBar.Search.Jobs'|translate}}</a>
          <a class="dropdown-item" href="javascript:void(0)" (click)="common.NavigateToRoute('Search/Candidates')">{{'TitleBar.Search.Candidates'|translate}}</a>
          <a class="dropdown-item" href="javascript:void(0)" (click)="common.NavigateToRoute('Search/Keyword')">{{'TitleBar.Search.KeywordSearch'|translate}}</a>
          <a class="dropdown-item" href="javascript:void(0)" (click)="common.NavigateToRoute('Search/JobAlerts')">{{'TitleBar.Search.JobAlerts'|translate}}</a>
          <a class="dropdown-item" href="javascript:void(0)" (click)="common.NavigateToRoute('Search/SmartSearch')">{{'TitleBar.Search.SmartSearch'|translate}}</a>
          <a class="dropdown-item" href="javascript:void(0)" (click)="common.NavigateToRoute('Search/SavedSearch/List')">{{'TitleBar.Search.SavedSearch'|translate}}</a>
          <a class="dropdown-item" href="javascript:void(0)" (click)="common.NavigateToRoute('Search/Talents')">{{'TitleBar.Search.TalentSearch'|translate}}</a>-->
          <!--<a class="dropdown-item" href="javascript:void(0)" (click)="navigateToMenu('5','Search/ApplicationSearch')">{{'TitleBar.Search.ApplicationSearch'|translate}}</a>
        </div>-->
      </li>
    }
    @if (featureReportBuilder && (isMyReportAllowed || isReportBuilderAllowed)) {
      <li  [ngClass]="[activeMenu === 4 ? ('nav-item dropdown active' + (activeReportMenu === true? ' show' : '')) : 'nav-item dropdown']" (click)="setActiveMenu('4');">
        <a class="nav-link headerReports" data-testid="btn-home-reports" aria-haspopup="true" aria-expanded="false" id="headerReports" [attr.aria-label]="'Notification.ReportsAltText' | translate">
          {{'TitleBar.Reports'|translate}}
        </a>
        <div class="dropdown-menu" aria-labelledby="headerReports" [class.show]="activeReportMenu">
          @if (isMyReportAllowed) {
            <a class="dropdown-item" data-testid="btn-my-reports" href="ReportBuilder/MyReports" (click)="common.NavigateToRoute(common.RouteUrls.ReportBuilder.MyReport);$event.preventDefault();">{{'Reports.MyReports.MyReports'|translate}}</a>
          }
          @if (isReportBuilderAllowed) {
            <a class="dropdown-item" data-testid="btn-report-builder" href="ReportBuilder/Index" (click)="common.NavigateToRouteWithQueryString(common.RouteUrls.ReportBuilder.Index,{ queryParams: { myReport: 1 } });$event.preventDefault();">{{'Reports.MyReports.ReportBuilder'|translate}}</a>
          }
        </div>
      </li>
    } @else {
      @if (isReportAllowed) {
        <li [ngClass]="[activeMenu === 4 ? 'nav-item active' : 'nav-item']" (click)="setActiveMenu('4')">
          <a class="nav-link headerReports" data-testid="btn-home-reports" id="headerReports" href="Reports/Index" (click)="setActiveMenu('4');common.NavigateToRoute('Reports/Index');$event.preventDefault();" [attr.aria-label]="'Notification.ReportsAltText' | translate">
            {{'TitleBar.Reports'|translate}}
          </a>
        </li>
      }
    }
    @if (isCalenderAllowed) {
      <li class="mobile-res-icons" name="calendaricon" [ngClass]="[activeMenu === 10 ? 'nav-item active' : 'nav-item']" (click)="setActiveMenu('10')">
        <a class="nav-link headerCalender" data-testid="btn-home-calendar" id="headerCalender" href="Calendar/ListEvent" (click)="setActiveMenu('10');common.NavigateToRoute('/Calendar/ListEvent');$event.preventDefault();" [attr.aria-label]="'Notification.CalenderIconAltText' | translate">
          <!--{{'TitleBar.Calendar'|translate}}-->
          <app-svg-icon class="nav-link-icon" [type]="'calendar'" [className]="'nav-link-icon'"></app-svg-icon>
        </a>
      </li>
    }
    @if (isSettingsAllowed && !isHideSettingsIcon) {
      <li class="mobile-res-icons" [ngClass]="[activeMenu == 6 ? 'nav-item active' : 'nav-item']" (click)="setActiveMenu('6')">
        <a class="nav-link" data-testid="btn-header-home-setting" id="headerSetting" href="Settings" (click)="sendTo('6','Settings');$event.preventDefault();" [attr.aria-label]="'Notification.SettingIconAltText' | translate">
          <app-svg-icon class="nav-link-icon" [type]="'Settings'" [className]="'nav-link-icon'"></app-svg-icon>
        </a>
      </li>
    }
    @if (!featureMyTasks) {
      <li class="mobile-res-icons dropdownNotifications" id="notificationsli" [ngClass]="[activeNotifications]" (click)="ShowHideNotifications()">
        <a id="notificationsAnchor" data-testid="btn-header-home-notifications" class="nav-link" href="javascript:void(0);" [attr.aria-label]="'Notification.NotificationIconAltText' | translate">
          <app-svg-icon class="nav-link-icon" [type]="'Notification'" [className]="'nav-link-icon'"></app-svg-icon>
        </a>
        @if (totalNotifications) {
          <span data-testid="span-total-notification" class="main-notification-alert">{{totalNotifications}}</span>
        }
      </li>
    } @else {
      <li class="mobile-res-icons dropdownNotifications" id="notificationsli"  [ngClass]="[activeMenu == 11 ? 'nav-item active' : 'nav-item']" (click)="setActiveMenu('11')">
        <a id="notificationsAnchor" data-testid="btn-header-enhanced-notifications" class="nav-link" href="Notifications" [attr.aria-label]="'Notification.NotificationIconAltText' | translate">
          <app-svg-icon class="nav-link-icon" [type]="'Notification'" [className]="'nav-link-icon'"></app-svg-icon>
        </a>
        <span data-testid="span-total-notification" class="main-notification-alert">{{enhancedNotificationCount}}</span>
      </li>
    }
    @if (HelpAndSupportShow) {
      <li class="mobile-res-icons" [ngClass]="[activeMenu === 8 ? 'nav-item active' : 'nav-item']" (click)="helpSuppor();">
        <a class="nav-link" data-testid="btn-header-home-help" id="headerHelp" href="javascript:void(0);"  [attr.aria-label]="'Notification.HelpAltText' | translate">
          <app-svg-icon class="nav-link-icon" [type]="'Help'" [className]="'nav-link-icon'"></app-svg-icon>
        </a>
      </li>
    }
    <li class="mobile-res-icons" [ngClass]="[activeMenu === 9 ? 'nav-item active' : 'nav-item']" (click)="RightInfoShow();">
      <a class="nav-link" data-testid="btn-header-home-right-side-menu" data-toggle="collapse" id="RightSideMenu" role="button" aria-expanded="false" aria-controls="UserSetting">
        <span class="user-img">{{ displayUserLogo() }}</span>
      </a>
    </li>
  </ul>
</div>
</nav>
}

<!--top Left Menu -->

@if (isDashboard===false && showTopHeader) {
  <div class="mian-quick-nav">
    <div>
      <div class="divquicklink">
        <button id="LeftSideMenu" data-testid="btn-jobs-quick-link" title="{{toolTip}}" type="button" [ngClass]="[bannerNavIcon]" [ngStyle]="{'display': (leftInfoAnimation === 'show' && IsEnableLeftInfoShow === true)?'none':'inline'}" href="javascript:void(0)" (click)="LeftInfoShow();" class="btn btn-primary btn_QuickLinks" data-toggle="collapse">
          <app-svg-icon id="LeftSideMenu" class="nav-link-icon" [type]="'menu-bar'" [className]="'nav-link-icon'"></app-svg-icon>
        </button>
      </div>
      <div id="quick-nav" [ngClass]="[IsEnableLeftInfoShow === true ? 'collapse show' : 'collapse', bannerQuickmenu]">
        <div class="scrollbar scrollbar-primary">
          <div class="force-overflow">
            <button type="button" href="javascript:void(0);" class="btn btn-link btn_QuickLinks">
              <app-svg-icon id="LeftSideMenu" class="nav-link-icon" [type]="'menu-bar'" [className]="'nav-link-icon'"></app-svg-icon>
            </button>
            <button id="closebutton-sec" type="button" href="javascript:void(0);" (click)="leftInfoClose()" class="btn btn-link" data-toggle="collapse" data-target="#quick-nav-sec">
              <app-svg-icon class="nav-link-icon" [type]="'button-close'" [className]="'nav-link-icon'"> </app-svg-icon>
            </button>
            <div class="mian-quick-nav-header">
              <h3>{{'TitleBar.LeftTopMenu.QuickLinks'|translate}}</h3>
            </div>
            <ul class="list-unstyled">
              @for (data of desktopItems; track data) {
                <li>
                  @if (data.itemType !== 'URLWithTLS') {
                    <a href="javascript:void(0)" (click)="Navigate(data)" class="sidenav-badge">
                      <span>
                        <app-svg-icon class="svg-icon" [type]="data.jT7SvgIcon" [className]="'svg-icon'"> </app-svg-icon>
                      </span>
                      @if (data.jT7Localization !== null && data.jT7Localization !== '') {
                        <i>
                          {{data.jT7Localization |translate}}
                        </i>
                      }
                      @if (data.jT7Localization === null || data.jT7Localization === '') {
                        <i>
                          {{data.itemTitle}}
                        </i>
                      }
                    </a>
                  }
                  @if (data.itemType === 'URLWithTLS' && trafficLightCount) {
                    <a href="javascript:void(0)" (click)="Navigate(data)" class="sidenav-badge sidenav-badge-margin">
                      <span>
                        <app-svg-icon class="svg-icon" [type]="data.jT7SvgIcon" [className]="'svg-icon'"> </app-svg-icon>
                      </span>
                      <i>
                        {{data.itemTitle}}<b>
                        @if (data.itemType === 'URLWithTLS' && data.graphDataType==='Unallocated') {
                          <i clickStopPropagation (click)="NavigateWithTlS(data,FDMTlsType.Unallocated)" class="badge badge-pill Unall-count">{{trafficLightCount.unallocateCount}}</i>
                        }
                        @if (data.graphDataType==='Allocated') {
                          <i clickStopPropagation (click)="NavigateWithTlS(data,FDMTlsType.Green)" class="badge badge-pill green-count">{{trafficLightCount.allocatedGreenCount}}</i>
                        }
                        @if (data.graphDataType==='Allocated') {
                          <i clickStopPropagation (click)="NavigateWithTlS(data,FDMTlsType.Amber)" class="badge badge-pill amber-count">{{ trafficLightCount.allocatedAmberCount}}</i>
                        }
                        @if (data.graphDataType==='Allocated') {
                          <i clickStopPropagation (click)="NavigateWithTlS(data,FDMTlsType.Red)" class="badge badge-pill red-count">{{ trafficLightCount.allocatedRedCount}}</i>
                        }
                        @if (data.graphDataType==='Reminders') {
                          <i clickStopPropagation (click)="NavigateWithTlS(data,FDMTlsType.Amber)" class="badge badge-pill amber-count">{{trafficLightCount.amberCount}}</i>
                        }
                        @if (data.graphDataType==='Reminders') {
                          <i clickStopPropagation (click)="NavigateWithTlS(data,FDMTlsType.Red)" class="badge badge-pill red-count">{{ trafficLightCount.redCount}}</i>
                        }
                        @if (data.graphDataType==='Reminders') {
                          <i clickStopPropagation (click)="NavigateWithTlS(data,FDMTlsType.Blue)" class="badge badge-pill blue-count">{{trafficLightCount.blueCount}}</i>
                        }
                        @if (data.graphDataType==='New') {
                          <i clickStopPropagation (click)="NavigateWithTlS(data,FDMTlsType.New)" class="badge badge-pill dark-brown-count">{{trafficLightCount.newCount}}</i>
                        }
                        @if (data.graphDataType==='EsrIntegration') {
                          <i class="badge badge-pill amber-count">{{trafficLightCount.totalPendingCount}}</i>
                        }
                        @if (data.graphDataType==='EsrIntegration') {
                          <i class="badge badge-pill red-count">{{ trafficLightCount.totalFailedCount}}</i>
                        }
                      </b>
                    </i>
                  </a>
                }
              </li>
            }
            <li class="company-logo">
              <div class="logo-image pic">
                @if (quickLinkLogo) {
                  <img [src]="quickLinkLogo" alt="Company Logo">
                }
                @if (quickLinkLogo===null || quickLinkLogo==='' && !IsJTGO) {
                  <img src="assets/images/JT_signin_Logo.gif" alt="Company Logo">
                }
                @if (quickLinkLogo===null || quickLinkLogo==='' && IsJTGO) {
                  <img src="assets/images/jtgo-logo.png" alt="Company Logo">
                }
              </div>
              <h4>{{'TitleBar.LeftTopMenu.Companylogo'|translate}} </h4>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
}

<!--Notifications-->
@if (showNotifications) {
  <div>
    <app-notifications (byLoad)="UpdateTotalNotifications($event)"></app-notifications>
  </div>
}
<!--Notifications end-->
<!--top Left Menu for dashboard-->

@if (isDashboard===true && showTopHeader) {
  <div class="mian-quick-nav" id="mian-quick-nav">
    <div class="divquicklink">
      <button id="button" type="button" title="{{toolTip}}" href="javascript:void(0)" data-bs-toggle="tooltip" data-bs-placement="top" [ngClass]="[bannerNavIcon]" [ngStyle]="{'display': (activeLeftSideMenu === true)?'none':'inline'}" (click)="openNav();" class="btn btn-primary btn_QuickLinks" data-target="#quick-nav">
        <app-svg-icon class="nav-link-icon" [type]="'menu-bar'" [className]="'nav-link-icon'"> </app-svg-icon>
      </button>
    </div>
    <div id="quick-nav" data-testid="quick-nav" [ngClass]="[activeLeftSideMenu === true ? 'collapse show' : 'collapse', bannerQuickmenu]">
      <div class="scrollbar scrollbar-primary">
        <div class="force-overflow">
          <button id="button" data-testid="btn-home-header-left-menu" type="button" title="{{toolTip}}" href="javascript:void(0)" class="btn btn-link btn_QuickLinks" data-toggle="collapse">
            <app-svg-icon id="LeftSideMenu" class="nav-link-icon" [type]="'menu-bar'" [className]="'nav-link-icon'"> </app-svg-icon>
          </button>
          <button data-testid="btn-home-page-left-menu-close" id="closebutton" type="button" href="javascript:void(0)" (click)="openNav();" class="btn btn-link" data-toggle="collapse" data-target="#quick-nav-dash">
            <app-svg-icon class="nav-link-icon" [type]="'button-close'" [className]="'nav-link-icon'"></app-svg-icon>
          </button>
          <div class="mian-quick-nav-header">
            <h3>{{'TitleBar.LeftTopMenu.QuickLinks'|translate}}</h3>
          </div>
          <ul class="list-unstyled">
            @for (data of desktopItems; track data) {
              <li>
                @if (data.itemType !== 'URLWithTLS') {
                  <a [attr.data-testid]="data.dataTestId" href="javascript:void(0)" (click)="Navigate(data)" class="sidenav-badge">
                    <span>
                      <app-svg-icon class="svg-icon" [type]="data.jT7SvgIcon" [className]="'svg-icon'"></app-svg-icon>
                    </span>
                    @if (data.jT7Localization !== null && data.jT7Localization !== '') {
                      <i>
                        {{data.jT7Localization |translate}}
                      </i>
                    }
                    @if (data.jT7Localization === null || data.jT7Localization === '') {
                      <i>
                        {{data.itemTitle}}
                      </i>
                    }
                  </a>
                }
                @if (data.itemType === 'URLWithTLS' && trafficLightCount) {
                  <a [attr.data-testid]="data.dataTestId" href="javascript:void(0)" (click)="Navigate(data)" class="sidenav-badge sidenav-badge-margin">
                    <span>
                      <app-svg-icon class="svg-icon" [type]="data.jT7SvgIcon" [className]="'svg-icon'"></app-svg-icon>
                    </span>
                    <i>
                      {{data.itemTitle}}
                      <b>
                        @if (data.itemType === 'URLWithTLS' && data.graphDataType==='Unallocated') {
                          <i clickStopPropagation (click)="NavigateWithTlS(data,FDMTlsType.Unallocated)" class="badge badge-pill Unall-count">{{trafficLightCount.unallocateCount}}</i>
                        }
                        @if (data.graphDataType==='Allocated') {
                          <i clickStopPropagation (click)="NavigateWithTlS(data,FDMTlsType.Green)" class="badge badge-pill green-count">{{trafficLightCount.allocatedGreenCount}}</i>
                        }
                        @if (data.graphDataType==='Allocated') {
                          <i clickStopPropagation (click)="NavigateWithTlS(data,FDMTlsType.Amber)" class="badge badge-pill amber-count">{{ trafficLightCount.allocatedAmberCount}}</i>
                        }
                        @if (data.graphDataType==='Allocated') {
                          <i clickStopPropagation (click)="NavigateWithTlS(data,FDMTlsType.Red)" class="badge badge-pill red-count">{{ trafficLightCount.allocatedRedCount}}</i>
                        }
                        @if (data.graphDataType==='Reminders') {
                          <i clickStopPropagation (click)="NavigateWithTlS(data,FDMTlsType.Amber)" class="badge badge-pill amber-count">{{trafficLightCount.amberCount}}</i>
                        }
                        @if (data.graphDataType==='Reminders') {
                          <i clickStopPropagation (click)="NavigateWithTlS(data,FDMTlsType.Red)" class="badge badge-pill red-count">{{ trafficLightCount.redCount}}</i>
                        }
                        @if (data.graphDataType==='Reminders') {
                          <i clickStopPropagation (click)="NavigateWithTlS(data,FDMTlsType.Blue)" class="badge badge-pill blue-count">{{trafficLightCount.blueCount}}</i>
                        }
                        @if (data.graphDataType==='New') {
                          <i clickStopPropagation (click)="NavigateWithTlS(data,FDMTlsType.New)" class="badge badge-pill dark-brown-count">{{trafficLightCount.newCount}}</i>
                        }
                        @if (data.graphDataType==='New') {
                          <i clickStopPropagation (click)="NavigateWithTlS(data,FDMTlsType.New)" class="badge badge-pill dark-brown-count">{{trafficLightCount.newCount}}</i>
                        }
                        @if (data.graphDataType==='EsrIntegration') {
                          <i class="badge badge-pill amber-count">{{trafficLightCount.totalPendingCount}}</i>
                        }
                        @if (data.graphDataType==='EsrIntegration') {
                          <i class="badge badge-pill red-count">{{ trafficLightCount.totalFailedCount}}</i>
                        }
                      </b>
                    </i>
                  </a>
                }
              </li>
            }
            <li class="company-logo">
              <div class="logo-image pic">
                @if (quickLinkLogo) {
                  <img [src]="quickLinkLogo" alt="Company Logo">
                }
                @if (quickLinkLogo===null || quickLinkLogo==='' && !IsJTGO) {
                  <img src="assets/images/JT_signin_Logo.gif " alt="Company Logo">
                }
                @if (quickLinkLogo===null || quickLinkLogo==='' && IsJTGO) {
                  <img src="assets/images/jtgo-logo.png" alt="Company Logo">
                }
              </div>
              <h4>{{'TitleBar.LeftTopMenu.Companylogo'|translate}} </h4>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
}


<!--top Right Menu-->

<div [ngClass]="[IsEnableRightInfoShow === true ? 'collapse show' : 'collapse']" class="collapse show" id="UserSetting" [@ShowHideAnimation]="rightInfoAnimation">
  <a data-toggle="collapse" data-testid="btn-close-right-menu" href="javascript:void(0)" (click)="rightMenuClose()" class="close-details" role="button" aria-expanded="true" aria-controls="UserSetting" data-target="#UserSetting">
    <app-svg-icon class="close-icon" [type]="'button-close'" [className]="'close-icon'"></app-svg-icon>
  </a>
  <div class="card card-body">
    <header>
      <div class="logo-image pic">
        <!-- <img src="img/user_pic.png" alt="">-->
        {{ displayUserLogo() }}
      </div>
      <div class="info my-auto">
        @if (userInfo) {
          <h5>{{userInfo.name }}</h5>
        }
        @if (userInfo) {
          <p>{{userInfo.emailAddress }}</p>
        }
        @if (userInfo) {
          <p>{{userInfo.securityRole }}</p>
        }
      </div>
    </header>
    <ul class="list-unstyled" data-testid="ul-right-menu">
      <li>
        <a class="dropdown-item" data-testid="btn-user-settings" href="javascript:void(0)" (click)="setActiveMenu('6');common.NavigateToRoute(common.RouteUrls.SystemUser.Detail);">{{'TitleBar.RightTopMenu.UserSettings'|translate}}</a>
      </li>
      @if (featureStripe) {
        <li>
          <a class="dropdown-item" data-testid="btn-view-receipts" href="javascript:void(0)" (click)="setActiveMenu('6');common.NavigateToRoute(common.RouteUrls.SystemUser.StripeOrderReceipts);">{{'TitleBar.RightTopMenu.ViewReceipts'|translate}}</a>
        </li>
      }
    </ul>
    <button type="button" id="logout" data-testid="btn-logout" class="btn btn-outline-success" (click)="logOut()" href="javascript:void(0)">{{'TitleBar.RightTopMenu.LogOut'|translate}}</button>

    <!--<div class="list-unstyled text-center mt-5 bottomText">-->
    <!--<a class="sidenav-badge bottomText text-center" (click)="contractUs()" href="javascript:void(0);">{{'Messages.Reportaproblem'|translate }}</a>-->
    <a class="sidenav-badge bottomText text-center" data-testid="btn-right-menu-bottom-text" (click)="jobTrainHelpDesk()" href="javascript:void(0);">{{'Messages.HelpDesk'|translate }}</a>

  <!--</div>-->
</div>


</div>
<div bsModal #HelpAndSupport="bs-modal" class="modal fade" tabindex="-1"
  role="dialog" aria-labelledby="dialog-child-name">
  <div class="helpAndSupportModal modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title pull-left"> {{'Help.Title' | translate}} </h2>
        <button type="button" class="close pull-right" aria-label="Close" (click)="closeHelp()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-horizontal">
          <div class="form-group row ml-2 mr-2">
            <div class="col-md-12">
              <p>{{'Help.NeedHelp'|translate}} <a href="javascript:void(0)" (click)="goToKnowledge_hub()">{{'Help.Online'|translate}}</a> for:</p>
              <ul class="fa-ul" style="padding-left: 50px;">
                <li style="padding-top: 10px;"><i class="fa-li fa fa-book fa-2x" style="color:#599BD2;"></i>{{'Help.UserGuides'|translate}}</li>
                <li style="padding-top: 10px;"><i class="fa-li fa fa-list fa-2x" style="color:#599BD2;"></i>{{'Help.Common'|translate}}</li>
                <li style="padding-top: 10px;"><i class="fa-li fa fa-globe fa-2x" style="color:#599BD2;"></i>{{'Help.TrainingWebinars'|translate}}</li>
              </ul>
              <p>&nbsp;</p>
              <p><span>{{'Help.Description1'|translate}}</span></p>
              <p><span>{{'Help.HelpDeskContact'|translate}} <a href="javascript:void(0)" (click)="goToHelpDesk()">{{'Help.ClickHere'|translate}}</a></span></p>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div [ngClass]="[cookieBannerBottom]"></div>
